import React, { Component } from 'react';
import {  Button , Container , Confirm , Dimmer, Form , Grid , Header , Icon , Label , Loader , Modal , Pagination , Progress , Table } from 'semantic-ui-react'; 
import * as constantes from '../../constantes';

import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE; 

const style = {
  h1: {
    marginTop: '1em',
  },
  h2: {
    margin: '1em 0em 1em',
  },
  h3: {
    marginTop: '2em',
    padding: '2em 0em',
  },
  last: {
    marginBottom: '300px',
  },
}

const _magistradoEmpty = { 
    magistradoId : '',
    abreviatura : '',
    apellidos : '',    
    nombres : '',
    estado : 1
}

export default class Magistrados extends Component{

  constructor(props) {
      super(props);
      this.state = {
            isLoaded: false,
            error: null,
            errors: [],

            activePage:1,
            totalPages:0,
            listaMagistrados: [],

            nuevoMagistrado : _magistradoEmpty,
            showModalEdit: false,
            confirmEliminarOpen : false,
            dimmerEliminar : false ,
            magistradoIdDelete : null

      };

        this.onPageChange = this.onPageChange.bind(this);
        this.nuevoMagistrado = this.nuevoMagistrado.bind(this);
        this.registrar = this.registrar.bind(this);
        this.eliminar = this.eliminar.bind(this);
        this._handlerChangeTextMagistradoObject = this._handlerChangeTextMagistradoObject.bind(this);

    }
 
    componentDidMount(){
        auth0Client.isExpired();
        this.cargarLista( 1 );
    }

    onPageChange (e, pageInfo) {
        let METHODNAME = 'onPageChange - ';
        console.log(METHODNAME + 'INI');

        console.log(METHODNAME + 'activePage = ' + pageInfo.activePage );

        this.setState({
            activePage : pageInfo.activePage
        });

        this.cargarLista( pageInfo.activePage );

    };

    async cargarLista( paginaActiva ){
        let METHODNAME = 'cargarLista - ';
        console.log(METHODNAME + 'INI');

        let url = server+`/magistrados`;
   
        let _rows = 10;

        let dataForm = null;
        dataForm = {
            "authUsername" : localStorage.getItem('usuario'),
            "pagina" : paginaActiva-1,
            "filas" : _rows
        }

        fetch( 
            url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            },
            body:JSON.stringify(dataForm)
        })
        .then(res => res.json())
        .then(
            
            (result) => {
                console.log(METHODNAME + 'RESULTADO DE LISTA DE MAGISTRADOS');
                
                this.setState({
                    isLoaded: true,
                    listaMagistrados: result.listaMagistrados,
                    activePage : paginaActiva, 
                    totalPages: result.totalPaginas,
                }); 

            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )
        console.log(METHODNAME + 'FIN');
    }

    _handlerChangeTextMagistradoObject( e ){
        let valor = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            nuevoMagistrado:{
              ...prevState.nuevoMagistrado,
              [name]: valor
            }
        }));
    }

    handleChangeBoolean( name , mostrar ){
        this.setState({
            [name]: mostrar
        });
    }

    nuevoMagistrado(){
        let METHODNAME = 'nuevoMagistrado - ';
        console.log(METHODNAME + 'INI.' );

        this.setState({
            nuevoMagistrado : _magistradoEmpty,
            showModalEdit:true
        });
    }

    registrar(){
        let METHODNAME = 'registrar - ';
        console.log(METHODNAME + 'INI');

        let url = server+`/magistrados/` ;
        
        if( this.state.nuevoMagistrado.abreviatura === '' || 
                this.state.nuevoMagistrado.apellidos === '' || 
                    this.state.nuevoMagistrado.nombres === '' ){
            console.error('No hay datos, completar campos');
            return;
        }

        let dataForm = {
            authUsername : localStorage.getItem('usuario'), 
            magistrado : { 
                magistradoId : this.state.nuevoMagistrado.magistradoId,
                abreviatura : this.state.nuevoMagistrado.abreviatura,
                apellidos : this.state.nuevoMagistrado.apellidos,
                nombres : this.state.nuevoMagistrado.nombres,
                estado : this.state.nuevoMagistrado.estado
            }
        }

        fetch( 
          url , {
          method: 'POST',
          headers:{
              'Accept':'application/json',
              'Content-Type':'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
          } ,
          body:JSON.stringify(dataForm)
        })
        .then(res => res.json())
        .then(
          
          (result) => {

            console.log(METHODNAME + 'RESULTADO');

            this.setState({
                isLoaded: true, 
                showModalEdit : false,
                nuevoMagistrado : _magistradoEmpty,
            });

            this.cargarLista( 1 );
            
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
              console.log(METHODNAME + 'error = ' + error );
              this.setState({
                  isLoaded: true,
                  error
              });
          }
      )
      console.log(METHODNAME + 'FIN');
    }
    
    preEliminar( magistradoId ){
        this.setState({
            confirmEliminarOpen: true , 
            magistradoIdDelete : magistradoId ,
            dimmerEliminar :  false 
        });
    }

    async eliminar(){
        let METHODNAME = 'eliminar - ';
        console.log( METHODNAME + 'INI ');
   
        if( this.state.magistradoIdDelete === null){
            console.log('No hay ID para eliminar');
            return;
        }

        this.setState({ 
            dimmerEliminar : true  
        });

        let url =  `${server}/magistrados/${this.state.magistradoIdDelete}/`;
        let dataForm = {
            authUsername : localStorage.getItem('usuario'),
        }
        const json = await fetch( url , {
            method: 'DELETE',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } ,
            body:JSON.stringify(dataForm)
        }).then((result) => {
           
            result.json().then((resp) => {

                if( resp.resultado === 'true' ){
                    console.warn(METHODNAME +  'eliminado correctamente.' );
                    
                    this.setState({
                        confirmEliminarOpen: false , 
                        magistradoIdDelete : null ,
                        dimmerEliminar :  false  
                    });

                    this.cargarLista( 1 );

                }else{
                    console.warn(METHODNAME +  'No se pudo eliminar ' );
                    console.warn(METHODNAME +  'error : ' + resp.error );

                    this.setState({ 
                        dimmerEliminar : false  
                    });

                }

            }).catch((error) => { 
                console.error(METHODNAME +  'Error al procesar respuesta: ' + error)
                this.setState({ 
                    dimmerEliminarAlternativa : false  
                });
            });

        }).catch((error) => { 
            console.error(METHODNAME +  'Server Error: ' + error)
        });

        return json;

    }

    render() {

        const { error, isLoaded,  listaMagistrados , activePage , totalPages } = this.state;

        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {

            return(
                <div>
            <Container>

                <Header as='h2' content='Lista de Magistrados' style={style.h1} textAlign='center' />

                <Button onClick={ () => this.nuevoMagistrado()}
                    color='green' size='tiny' >
                <Icon name="save" />
                Agregar nuevo Magistrado
                </Button>
                
                <Table celled>
                        <Table.Header>
                            <Table.Row key='head0002'> 
                                <Table.HeaderCell>Código</Table.HeaderCell>
                                <Table.HeaderCell>Abreviatura</Table.HeaderCell>
                                <Table.HeaderCell>Nombres</Table.HeaderCell>
                                <Table.HeaderCell>Apellidos</Table.HeaderCell> 
                                <Table.HeaderCell>Estado</Table.HeaderCell>
                                <Table.HeaderCell>Acciones</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                
                        <Table.Body>
                            
                            { listaMagistrados && listaMagistrados.map(magistrado => (
                                <Table.Row  key={magistrado.magistradoId} className={magistrado.estado === 1 ? '' : 'negative'} >
                                    <Table.Cell> <Label ribbon>{magistrado.magistradoId}</Label> </Table.Cell>
                                    <Table.Cell>{magistrado.abreviatura}</Table.Cell>
                                    <Table.Cell>{magistrado.nombres}</Table.Cell>
                                    <Table.Cell>{magistrado.apellidos}</Table.Cell>
                                    <Table.Cell>
                                        {magistrado.estado === 1 ? 'Activo' : 'Eliminado'}
                                    </Table.Cell>
                                    <Table.Cell>
                                        { magistrado.estado === 1 &&
                                        <Button color='red' animated="vertical" size='mini'
                                                onClick={ () => this.preEliminar(magistrado.magistradoId)}  >
                                            <Button.Content visible>
                                                <Icon name="trash alternate outline" />
                                            </Button.Content>
                                            <Button.Content hidden>
                                                Eliminar
                                            </Button.Content>
                                        </Button>  
                                        }
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                            
                        </Table.Body>
                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan='8' textAlign='center'>
                                    <Pagination 
                                        activePage={activePage} 
                                        onPageChange={this.onPageChange}
                                        totalPages={totalPages} />
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    </Table>

                    <Confirm
                        open={this.state.confirmEliminarOpen}
                        header='Eliminar Registro'
                        content='¿Está seguro que desea eliminar el registro seleccionado?'
                        onCancel={ () => this.handleChangeBoolean('confirmEliminarOpen', false )} 
                        onConfirm={this.eliminar}
                    />

                    <Dimmer active={this.state.dimmerEliminar} inverted >
                        <Loader>Loading</Loader>
                    </Dimmer>
                    
                    <Modal
                        as={Form} 
                        onSubmit={this.registrar} 
                        closeIcon
                        closeOnEscape={false}
                        onClose={() => this.handleChangeBoolean( 'showModalEdit' , false)} 
                        open={this.state.showModalEdit}
                    >
                        <Modal.Header>Información de Magistrado</Modal.Header>

                        <Modal.Content>
                            <Modal.Description>
                                <Grid columns={2}>
                                    <Grid.Row>
                                        <Grid.Column width={6}>
                                            Abreviatura:
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <input placeholder='Abreviatura' 
                                                id='abreviatura' name='abreviatura'
                                                value={this.state.nuevoMagistrado.abreviatura} 
                                                onChange = {this._handlerChangeTextMagistradoObject}/> 
                                        </Grid.Column>
                                        
                                    </Grid.Row>
                                </Grid>
                                <Grid columns={2}>
                                    <Grid.Row>
                                        <Grid.Column width={6}>
                                            Nombres: 
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <input placeholder='Nombres' 
                                                id='nombres' name='nombres'
                                                value={this.state.nuevoMagistrado.nombres} 
                                                onChange = {this._handlerChangeTextMagistradoObject}/> 
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                <Grid columns={2}>
                                    <Grid.Row>
                                        <Grid.Column width={6}>
                                            Apellidos: 
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <input placeholder='Apellidos'
                                                id='apellidos' name='apellidos'
                                                value={this.state.nuevoMagistrado.apellidos} 
                                                onChange = {this._handlerChangeTextMagistradoObject}/> 
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Modal.Description>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button color='blue' onClick={() => this.handleChangeBoolean( 'showModalEdit' ,false)}>
                                Cancelar
                            </Button>
                            <Button
                                content="Regsitrar"
                                labelPosition='right'
                                icon='checkmark'
                                type='submit'
                                color='red'
                            /> 
                        </Modal.Actions>

                    </Modal>
 
            </Container>

             
            </div>
            );

        }
  }

}